"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineMenu = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const slate_1 = require("slate");
const ui_1 = require("@jsonjoy.com/ui");
const FontStyleButton_1 = require("@jsonjoy.com/ui/lib/2-inline-block/FontStyleButton");
const Sidetip_1 = require("@jsonjoy.com/ui/lib/1-inline/Sidetip");
const keys_1 = require("../util/keys");
const behavior_1 = require("../behavior");
const font_1 = require("../behavior/font");
const color_1 = require("../behavior/color");
const MarkSwatchPanel_1 = require("./MarkSwatchPanel");
const ColorPickerPanel_1 = require("./ColorPickerPanel");
const math_1 = require("../behavior/math");
const font_bold_1 = tslib_1.__importDefault(require("iconista/lib/react/radix/font-bold"));
const italic_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/italic"));
const underline_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/underline"));
const overline_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/overline"));
const strikethrough_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/strikethrough"));
const highlight_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/highlight"));
const lock_password_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/lock-password"));
const code_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/code"));
const superscript_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/superscript"));
const subscript_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/subscript"));
const keyboard_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/keyboard"));
const pencil_plus_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/pencil-plus"));
const pencil_minus_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/pencil-minus"));
const link_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/link"));
const paintbrush_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/paintbrush"));
const paint_bucket_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/paint-bucket"));
const math_function_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/math-function"));
const eraser_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/eraser"));
const typography_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/typography"));
// Formatting: common
const BoldIcon = (props) => (React.createElement(font_bold_1.default, { width: 15, height: 15, ...props }));
const ItalicIcon = (props) => (React.createElement(italic_1.default, { width: 16, height: 16, ...props }));
const UnderlineIcon = (props) => (React.createElement(underline_1.default, { width: 16, height: 16, ...props }));
const OverlineIcon = (props) => (React.createElement(overline_1.default, { width: 16, height: 16, ...props }));
const StrikethroughIcon = (props) => (React.createElement(strikethrough_1.default, { width: 16, height: 16, ...props }));
const HighlightIcon = (props) => (React.createElement(highlight_1.default, { width: 16, height: 16, ...props }));
const SpoilerIcon = (props) => (React.createElement(lock_password_1.default, { width: 16, height: 16, ...props }));
// Formatting: technical
const CodeIcon = (props) => (React.createElement(code_1.default, { width: 16, height: 16, ...props }));
const SupIcon = (props) => React.createElement(superscript_1.default, { width: 16, height: 16, ...props });
const SubIcon = (props) => React.createElement(subscript_1.default, { width: 16, height: 16, ...props });
const KeyIcon = (props) => React.createElement(keyboard_1.default, { width: 16, height: 16, ...props });
const InsertionIcon = (props) => (React.createElement(pencil_plus_1.default, { width: 16, height: 16, ...props }));
const DeletionIcon = (props) => (React.createElement(pencil_minus_1.default, { width: 16, height: 16, ...props }));
// Annotations
const LinkIcon = (props) => (React.createElement(link_1.default, { width: 15, height: 15, ...props }));
const FgIcon = (props) => React.createElement(paintbrush_1.default, { width: 16, height: 16, ...props });
const BgIcon = (props) => React.createElement(paint_bucket_1.default, { width: 16, height: 16, ...props });
const MathIcon = (props) => (React.createElement(math_function_1.default, { width: 16, height: 16, ...props }));
// Modify
const ClearFormattingIcon = (props) => (React.createElement(eraser_1.default, { width: 16, height: 16, ...props }));
// Typesetting
const TypographyIcon = (props) => (React.createElement(typography_1.default, { width: 16, height: 16, ...props }));
const RECENT_LIMIT = 4;
class InlineMenu {
    constructor(mutxt) {
        this.mutxt = mutxt;
        this.recent = ui_1.rsync.val([]);
        this.addRecent = (item) => {
            const key = item.id ?? item.name;
            const next = [item, ...this.recent.value.filter((r) => (r.id ?? r.name) !== key)];
            if (next.length > RECENT_LIMIT)
                next.length = RECENT_LIMIT;
            this.recent.set(next);
        };
    }
    start() {
        return () => { };
    }
    markActive(mark) {
        return ui_1.rsync.comp([this.mutxt.version], () => (0, behavior_1.isMarkActive)(this.mutxt.editor, mark));
    }
    menuRecent() {
        const list = this.recent.value;
        if (list.length === 0)
            return null;
        return {
            id: 'recent',
            name: 'Recent',
            expand: RECENT_LIMIT,
            children: list,
        };
    }
    build() {
        const recent = this.menuRecent();
        const children = [
            ...(recent ? [recent, { name: 'sep-recent', sep: true }] : []),
            this.menuFmt(),
            { name: 'sep-annon', sep: true },
            this.menuAnnotations({ anchorFromSelection: true }),
            { name: 'sep-typesetting', sep: true },
            this.menuTypesetting(),
            { name: 'sep-modify', sep: true },
            this.menuModify(),
        ];
        return {
            name: 'Selection menu',
            maxToolbarItems: recent ? 5 : 4,
            children,
        };
    }
    buildToolbarMenu() {
        return {
            name: 'Selection menu',
            maxToolbarItems: 4,
            children: [
                this.menuFmt(),
                { name: 'sep-annon', sep: true },
                this.menuAnnotations(),
                { name: 'sep-typesetting', sep: true },
                this.menuTypesetting(),
                { name: 'sep-modify', sep: true },
                this.menuModify(),
            ],
        };
    }
    menuFmt() {
        const formatting = {
            name: 'Formatting',
            expandChild: 0,
            // preview: this.recent,
            children: [this.menuFmtCommon(), this.menuFmtTechnical(), this.menuFmtColors()],
            preview: [
                this.itemBold(),
                this.itemItalic(),
                this.itemUnderline(),
                this.itemCode(),
                this.itemHighlight(),
                this.itemFg(),
                this.itemBg(),
            ],
        };
        return formatting;
    }
    menuFmtCommon() {
        return {
            id: 'fmt-common',
            name: 'Common',
            expand: 8,
            children: [
                this.itemBold(),
                this.itemItalic(),
                this.itemUnderline(),
                this.itemStrikethrough(),
                this.itemOverline(),
                this.itemHighlight(),
                this.itemSpoiler(),
            ],
        };
    }
    itemBold() {
        const keys = ['Primary', 'b'];
        return {
            mark: 'bold',
            name: 'Bold',
            text: 'strong heavy thick weight',
            icon: () => React.createElement(BoldIcon, null),
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, (0, keys_1.formatKeys)(keys)),
            keys: [(0, keys_1.formatKeys)(keys)],
            active: this.markActive('bold'),
            onSelect: () => {
                this.mutxt.api.toggleMark('bold');
            },
        };
    }
    itemItalic() {
        const keys = ['Primary', 'i'];
        return {
            mark: 'italic',
            name: 'Italic',
            text: 'em emphasis slant oblique cursive',
            icon: () => React.createElement(ItalicIcon, null),
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, (0, keys_1.formatKeys)(keys)),
            keys: [(0, keys_1.formatKeys)(keys)],
            active: this.markActive('italic'),
            onSelect: () => {
                this.mutxt.api.toggleMark('italic');
            },
        };
    }
    itemUnderline() {
        const keys = ['Primary', 'u'];
        return {
            mark: 'underline',
            name: 'Underline',
            text: 'underscore line under',
            icon: () => React.createElement(UnderlineIcon, null),
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, (0, keys_1.formatKeys)(keys)),
            keys: [(0, keys_1.formatKeys)(keys)],
            active: this.markActive('underline'),
            priority: 1,
            onSelect: () => {
                this.mutxt.api.toggleMark('underline');
            },
        };
    }
    itemStrikethrough() {
        const keys = ['Primary', 'Shift', 'x'];
        return {
            mark: 'strikethrough',
            name: 'Strikethrough',
            text: 'strike crossed line through cross-out',
            icon: () => React.createElement(StrikethroughIcon, null),
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, (0, keys_1.formatKeys)(keys)),
            keys: [(0, keys_1.formatKeys)(keys)],
            active: this.markActive('strikethrough'),
            onSelect: () => {
                this.mutxt.api.toggleMark('strikethrough');
            },
        };
    }
    itemOverline() {
        return {
            mark: 'overline',
            name: 'Overline',
            text: 'line over above top',
            icon: () => React.createElement(OverlineIcon, null),
            active: this.markActive('overline'),
            onSelect: () => {
                this.mutxt.api.toggleMark('overline');
            },
        };
    }
    itemHighlight() {
        const mutxt = this.mutxt;
        return {
            name: 'Highlight',
            text: 'mark yellow background marker emphasis color',
            icon: () => React.createElement(HighlightIcon, null),
            active: ui_1.rsync.comp([mutxt.version], () => (0, color_1.getActiveMarkColor)(mutxt.editor) !== undefined),
            pane: () => React.createElement(MarkSwatchPanel_1.MarkSwatchPanel, { mutxt: mutxt }),
        };
    }
    itemFg() {
        const mutxt = this.mutxt;
        return {
            name: 'Text color',
            text: 'fg foreground font color text',
            icon: () => React.createElement(FgIcon, null),
            active: ui_1.rsync.comp([mutxt.version], () => !!(0, color_1.getActiveFg)(mutxt.editor)),
            pane: () => React.createElement(ColorPickerPanel_1.ColorPickerPanel, { mutxt: mutxt, kind: "fg" }),
        };
    }
    itemBg() {
        const mutxt = this.mutxt;
        return {
            name: 'Background color',
            text: 'bg background fill color shading',
            icon: () => React.createElement(BgIcon, null),
            active: ui_1.rsync.comp([mutxt.version], () => !!(0, color_1.getActiveBg)(mutxt.editor)),
            pane: () => React.createElement(ColorPickerPanel_1.ColorPickerPanel, { mutxt: mutxt, kind: "bg" }),
        };
    }
    itemSpoiler() {
        return {
            mark: 'spoiler',
            name: 'Spoiler',
            text: 'hide blur reveal redact secret hidden',
            icon: () => React.createElement(SpoilerIcon, null),
            active: this.markActive('spoiler'),
            onSelect: () => {
                this.mutxt.api.toggleMark('spoiler');
            },
        };
    }
    menuFmtTechnical() {
        return {
            id: 'fmt-technical',
            name: 'Technical',
            expand: 8,
            sepBefore: true,
            children: [
                this.itemCode(),
                this.itemMath(),
                this.itemSup(),
                this.itemSub(),
                this.itemKey(),
                this.itemIns(),
                this.itemDel(),
            ],
        };
    }
    menuFmtColors() {
        return {
            id: 'fmt-colors',
            name: 'Colors',
            expand: 8,
            sepBefore: true,
            children: [this.itemFg(), this.itemBg()],
        };
    }
    itemCode() {
        const keys = ['Primary', 'e'];
        return {
            mark: 'code',
            name: 'Code',
            text: 'inline monospace snippet variable identifier',
            icon: () => React.createElement(CodeIcon, { width: 16, height: 16 }),
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, (0, keys_1.formatKeys)(keys)),
            keys: [(0, keys_1.formatKeys)(keys)],
            active: this.markActive('code'),
            onSelect: () => {
                this.mutxt.api.toggleMark('code');
            },
        };
    }
    itemSup() {
        return {
            mark: 'sup',
            name: 'Superscript',
            text: 'sup raised exponent power above',
            icon: () => React.createElement(SupIcon, null),
            active: this.markActive('sup'),
            onSelect: () => {
                this.mutxt.api.toggleMark('sup');
            },
        };
    }
    itemSub() {
        return {
            mark: 'sub',
            name: 'Subscript',
            text: 'sub lowered chemistry below index',
            icon: () => React.createElement(SubIcon, null),
            active: this.markActive('sub'),
            onSelect: () => {
                this.mutxt.api.toggleMark('sub');
            },
        };
    }
    itemKey() {
        return {
            mark: 'kbd',
            name: 'Keyboard key',
            text: 'kbd shortcut button keystroke key',
            priority: 1,
            icon: () => React.createElement(KeyIcon, null),
            active: this.markActive('kbd'),
            onSelect: () => {
                this.mutxt.api.toggleMark('kbd');
            },
        };
    }
    itemIns() {
        return {
            mark: 'ins',
            name: 'Insertion',
            text: 'ins added inserted track changes diff',
            icon: () => React.createElement(InsertionIcon, null),
            active: this.markActive('ins'),
            onSelect: () => {
                this.mutxt.api.toggleMark('ins');
            },
        };
    }
    itemDel() {
        return {
            mark: 'del',
            name: 'Deletion',
            text: 'del removed deleted track changes diff strike',
            icon: () => React.createElement(DeletionIcon, null),
            active: this.markActive('del'),
            onSelect: () => {
                this.mutxt.api.toggleMark('del');
            },
        };
    }
    menuAnnotations(opts = {}) {
        return {
            name: 'Annotations',
            expand: 3,
            children: [this.itemLink(opts)],
        };
    }
    itemMath() {
        const mutxt = this.mutxt;
        return {
            name: 'Equation',
            text: 'math equation formula latex inline tex',
            icon: () => React.createElement(MathIcon, null),
            active: ui_1.rsync.comp([mutxt.version], () => !!(0, math_1.getActiveMathInlineEntry)(mutxt.editor)),
            onSelect: (event) => {
                event.preventDefault();
                const entry = (0, math_1.getActiveMathInlineEntry)(mutxt.editor);
                if (entry) {
                    mutxt.inline.math.openEdit(entry[0], entry[1]);
                }
                else {
                    mutxt.inline.math.openInsert();
                }
            },
        };
    }
    itemLink(opts = {}) {
        const mutxt = this.mutxt;
        const link = mutxt.inline.link;
        return {
            name: 'Link',
            text: 'url href hyperlink anchor web address a',
            icon: () => React.createElement(LinkIcon, null),
            disabled: ui_1.rsync.comp([link.canOpen], ([canOpen]) => !canOpen),
            active: ui_1.rsync.comp([mutxt.caretLinkHref], ([href]) => !!href),
            onSelect: (event) => {
                if (opts.anchorFromSelection) {
                    link.setAnchorFromSelection();
                }
                else {
                    const trigger = event.currentTarget;
                    if (trigger)
                        link.setAnchorEl(trigger);
                }
                mutxt.inline.dismissed.next(true);
                link.toggle();
            },
        };
    }
    menuTypesetting() {
        return {
            id: 'inline-typesetting',
            name: 'Typesetting',
            text: 'font face family typography typeface',
            icon: () => React.createElement(TypographyIcon, null),
            expand: 4,
            openOnTitleHov: true,
            children: [
                this.itemLeafFont('sans', 'Sans-serif', 'sans gothic grotesque modern'),
                this.itemLeafFont('serif', 'Serif', 'serif traditional roman'),
                this.itemLeafFont('slab', 'Slab', 'slab egyptian thick serif'),
                this.itemLeafFont('mono', 'Monospace', 'mono fixed code typewriter courier'),
            ],
        };
    }
    itemLeafFont(kind, name, text) {
        const mutxt = this.mutxt;
        const onSelect = (event) => {
            event.preventDefault();
            (0, font_1.setLeafFont)(mutxt.editor, kind);
            mutxt.sync(false);
        };
        const Option = ({ size }) => {
            mutxt.version.use();
            const active = (0, font_1.isLeafFontActive)(mutxt.editor, kind);
            return React.createElement(FontStyleButton_1.FontStyleButton, { kind: kind, size: size, active: active, onMouseDown: onSelect });
        };
        return {
            name,
            text,
            icon: () => React.createElement(Option, { size: 16 }),
            iconBig: () => React.createElement(Option, null),
            active: ui_1.rsync.comp([mutxt.version], () => (0, font_1.isLeafFontActive)(mutxt.editor, kind)),
            onSelect,
        };
    }
    menuModify() {
        return {
            name: 'Modify',
            expand: 3,
            onSelect: () => { },
            children: [this.itemClear()],
        };
    }
    itemClear() {
        const { mutxt } = this;
        return {
            name: 'Erase formatting',
            text: 'clear remove reset plain unformat strip styles marks',
            danger: true,
            icon: () => React.createElement(ClearFormattingIcon, { width: 16, height: 16 }),
            disabled: ui_1.rsync.comp([mutxt.version], () => {
                const sel = mutxt.editor.selection;
                return !sel || slate_1.Range.isCollapsed(sel);
            }),
            onSelect: () => {
                mutxt.api.eraseMarks();
            },
        };
    }
}
exports.InlineMenu = InlineMenu;
